module.exports = __webpack_public_path__ + "static/img/github-button.f41fb0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nMobile-download/github-button.png
// module id = frR0
// module chunks = 1